var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "19",
        viewBox: "0 0 17 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M14.7094 6.06918C15.9504 5.77738 16.875 4.66293 16.875 3.33051C16.875 1.7766 15.6164 0.518005 14.0625 0.518005C12.5367 0.518005 11.2957 1.7309 11.25 3.24261L4.78828 5.83011C4.27852 5.32738 3.58242 5.01801 2.8125 5.01801C1.25859 5.01801 0 6.2766 0 7.83051C0 9.38441 1.25859 10.643 2.8125 10.643C3.24141 10.643 3.64922 10.5481 4.01133 10.3758L9.13008 14.8547C9.0457 15.1219 9 15.4102 9 15.7055C9 17.2594 10.2586 18.518 11.8125 18.518C13.3664 18.518 14.625 17.2594 14.625 15.7055C14.625 14.7317 14.1328 13.8739 13.3805 13.3711L14.7094 6.06918ZM5.49492 8.68129C5.57227 8.43871 5.61797 8.18207 5.625 7.9184L12.0867 5.33441C12.2133 5.45746 12.3469 5.56996 12.4945 5.6684L11.1656 12.9668C10.9723 13.0125 10.7859 13.0758 10.6102 13.1602L5.49492 8.68129Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }